export default "__VITE_ASSET__rUta_CXn__"